// 项目评价风险分析表
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行-项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <el-input :disabled="!isSubmit" v-model="addFormData.project_name"></el-input>
      </div>
    </div>
    <!-- 第二行-项目类型and许可类型 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_xmlx@2x.png" alt />
          <span>项目类型</span>
        </div>
        <div class="rightInput">
          <!-- <el-select v-model="infop" placeholder="请选择">
            <el-option
              v-for="item in projectTypeList"
              :key="item.project_type_id"
              :label="item.project_type_name"
              :value="item.project_type_id"
            ></el-option>
          </el-select>-->
          <span class="isNotSubmitSpan">{{addFormData.project_type_name}}</span>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:15px" src="../../assets/image/icon_xklx@2x.png" alt />
          <span>许可类型</span>
        </div>
        <div class="rightInput">
          <!-- <el-select v-model="infop" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>-->
          <span v-if="addFormData.permit_type=='1'" class="isNotSubmitSpan">一般类</span>
          <span v-if="addFormData.permit_type=='2'" class="isNotSubmitSpan">许可类</span>
        </div>
      </div>
    </div>
    <!-- 第三行--评价类型 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel upLoadLabel" style="padding-top:0">
        <img style="width:16px;margin-top:12px" src="../../assets/image/icon_pingjialx@2x.png" alt />
        <span style="margin-top:8px">评价类型</span>
      </div>
      <div class="rightInput rightRadioWithInput">
        <el-radio-group :disabled="!isSubmit" v-model="addFormData.pte_id" @change="handleOtherIs">
          <el-radio v-for="item in projectPjList" :label="item.pte_id">{{item.pte_name}}</el-radio>
          <div>
            <el-radio :label="'-1'">其他</el-radio>
            <el-input :disabled="isTypeInputDis || !isSubmit" v-model="addFormData.pte_else"></el-input>
          </div>
        </el-radio-group>
      </div>
    </div>-->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel upLoadLabel" style="padding-top:0">
        <img style="width:16px;margin-top:12px" src="../../assets/image/icon_pingjialx@2x.png" alt />
        <span style="margin-top:8px">评价类型</span>
      </div>
      <div class="rightInput">
        <!-- :disabled="!isSubmit"  -->
        <el-cascader
          v-if="isSubmit"
          placeholder="请选择评价类型"
          style="width:100%;"
          v-model="cascaderArr"
          clearable
          :props="plProps"
          :options="projectPjList"
          filterable
        ></el-cascader>
        <span v-else class="isNotSubmitSpan">{{addFormData.pte_abbreviation_show}}</span>
      </div>
    </div>

    <!-- 第四行--参与风险分析人员 -->
    <div class="oneRow" style="margin-bottom:35px;">
      <div class="leftLabel upLoadLabel" style="width:180px">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span style="width:140px!important">参与风险分析人员</span>
      </div>
      <div class="rightInput">
        <!-- <my-transfer
          v-if="isSubmit"
          :selectedId="selectIds"
          style="width:100%"
          @my-transfer-change="transferChange"
        ></my-transfer>
        <span v-else class="isNotSubmitSpan">
          <span style="display:block" v-for="item in addFormData.analysts_list">{{item.nickname}}</span>
        </span>-->
        <el-input
          :disabled="!isSubmit"
          :placeholder="isSubmit ? '输入参与风险分析人员' : ''"
          v-model="addFormData.analysts"
        ></el-input>
      </div>
    </div>
    <!-- 第五行--项目存在的主要危险有害因素 -->
    <div class="oneRow onRowWith2Input" style="margin-bottom:10px">
      <div class="leftLabel" style="width:300px">
        <img style="width:16px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>项目存在的主要危险有害因素</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.project_overview"
        type="textarea"
        :autosize="{minRows: 3}"
      ></el-input>
    </div>

    <!-- 第六行--风险分析内容 -->
    <div class="oneRow" style="margin-bottom:10px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icon_fxian@2x.png" alt />
        <span>风险分析内容</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
      <p class="liRadioWithInput" v-for="item in liRadioWithInputOptions" :key="item.name">
        <!-- <span class="title" :title="item.name">{{item.name}}</span> -->
        <el-tooltip
          transition="none"
          class="item"
          effect="dark"
          :content="item.name"
          placement="top-start"
        >
          <span class="title">{{item.name}}</span>
        </el-tooltip>
        <el-radio-group :disabled="!isSubmit" v-model="item.value" @change="handleChange">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
        <span class="beizhu">备注</span>
        <el-input
          :disabled="!isSubmit"
          :placeholder="isSubmit ? '请输入备注内容' : ''"
          v-model="item.remark"
        ></el-input>
      </p>
    </div>
    <!-- 第七行-分析结论 -->
    <div class="oneRow onRowWith2Input" style="margin-bottom:10px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icon_yijian@2x.png" alt />
        <span>分析结论</span>
      </div>
      <div class="rightLabelWitInput">
        <img style="width:15px;margin-right:10px" src="../../assets/image/icon_yijian@2x.png" alt />
        <span style="margin-right:20px">日期</span>
        <el-date-picker
          v-model="addFormData.charge_opinions_time"
          value-format="yyyy-MM-dd"
          :disabled="!isSubmit"
          type="date"
          :placeholder="isSubmit ? '选择日期' : ''"
        ></el-date-picker>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.charge_opinions"
        type="textarea"
        :autosize="{minRows: 3}"
      ></el-input>
    </div>
    <!-- 第八行--技术负责人审批意见 -->
    <div class="oneRow onRowWith2Input" style="margin-bottom:10px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icon_yijian@2x.png" alt />
        <span>技术负责人审批意见</span>
      </div>
      <div class="rightLabelWitInput">
        <img style="width:15px;margin-right:10px" src="../../assets/image/icon_yijian@2x.png" alt />
        <span style="margin-right:20px">日期</span>
        <el-date-picker
          v-model="addFormData.approval_opinions_time"
          @change="handleDA"
          value-format="yyyy-MM-dd"
          :disabled="!isSubmit"
          type="date"
          :placeholder="isSubmit ? '选择日期' : ''"
        ></el-date-picker>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.approval_opinions"
        type="textarea"
        :autosize="{minRows: 3}"
      ></el-input>
    </div>
    <!-- 第九行--状态 -->
    <!-- 上传 -->
    <div class="oneRow" type="min-height:60px">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>
    <!-- 上传 -->
    <!-- 项目如需安全评价风险分析表 -->
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:12px;">*项目如需安全评价风险分析表:</div>
        <a
          style="font-size:14px;"
          href="https://control.sxpz.vip/Template/安全评价风险分析表.doc"
        >安全评价风险分析表.doc</a>
      </div>
    </div>
    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button v-if="addFormData.is_edit!='1'" @click="handleSubmit('1')">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status=='1'"
        @click="handleProjectWithDraw"
        style="background-color:rgb(255, 26, 26);"
      >撤回</el-button>
      <el-button
        v-if="addFormData.is_edit!='1'"
        @click="handleSubmit('0')"
        style="background-color:#40A0F2"
      >提 交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'13'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import MyTransfer from '../MyTransfer'
import UploadFile from '../UploadFile'
export default {
  data() {
    return {
      cascaderArr: [],
      plProps: {
        value: 'pte_id',
        label: 'pte_name',
      },
      tiemID: null,
      timeDou: 100,
      detailsImgList: [],
      submitImgList: [],
      approval_remark: '',
      isSubmit: true,
      selectIds: [],
      infop: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      projectTypeList: [],
      projectPjList: [],
      value: '',
      addFormData: {
        annex: '',
        project_name: '',
        pte_id: '',
        pte_else: '',
        analysts: '',
        project_overview: '',
        project_type_id: '',
        permit_type: '',
        analysis_1st: '',
        analysis_2nd: '',
        analysis_3rd: '',
        analysis_4th: '',
        analysis_5th: '',
        analysis_6th: '',
        analysis_7th: '',
        analysis_8th: '',
        analysis_9th: '',
        analysis_10th: '',
        remark_of_analysis_1st: '1',
        remark_of_analysis_2nd: '1',
        remark_of_analysis_3rd: '1',
        remark_of_analysis_4th: '1',
        remark_of_analysis_5th: '1',
        remark_of_analysis_6th: '1',
        remark_of_analysis_7th: '1',
        remark_of_analysis_8th: '1',
        remark_of_analysis_9th: '1',
        remark_of_analysis_10th: '1',
        charge_opinions: '',
        charge_opinions_time: '',
        approval_opinions: '',
        approval_opinions_time: '',
      },
      liRadioWithInputOptions: [
        {
          // name: '1.未超评价业务范围',
          name: '1.委托方具备委托资质，评价项目是否合法',
          value: '1',
          remark: '',
        },
        {
          // name: '2.项目是否符合国家产业政策',
          name: '2.委托方的行业安全风险是否能够承受并控制',
          value: '1',
          remark: '',
        },
        {
          // name: '3.该项目的行业风险是否在可控制范围内',
          name: '3.是否在本机构的资质业务范围之内；公司是否具有满足合同要求的能力（人员条件、设备条件、时间要求等）',
          value: '1',
          remark: '',
        },
        {
          // name: '4.是否属于矿山、金属冶炼、危化行业',
          name: '4.本机构安全评价人员的技术能力、技术构成（专业配置）是否符合',
          value: '1',
          remark: '',
        },
        {
          // name: '5.是否存在两重点或一重大',
          name: '5.委托方的营业执照和其他法定的证件是否齐全',
          value: '1',
          remark: '',
        },
        {
          // name: '6.是否属于许可类项目',
          name: '6.评价所需的主要基础资料是否具备',
          value: '1',
          remark: '',
        },
        {
          // name: '7.评价费用未低于市场价或预期利润低',
          name: '7.安全隐患短时期内是否能整改到位',
          value: '1',
          remark: '',
        },
        {
          // name: '8.业主未提出无理要求',
          name: '8.评价费用是否低于市场价或预期利润低',
          value: '0',
          remark: '',
        },
        {
          // name: '9.未超出本公司自身业务能力',
          name: '9.业主是否提出无理要求',
          value: '0',
          remark: '',
        },
        {
          // name: '9.未超出本公司自身业务能力',
          name: '10.公司是否有能力赔偿由于安全评价原因造成事故的损失',
          value: '1',
          remark: '',
        },
      ],
      options: [
        {
          value: '2',
          label: '许可类',
        },
        {
          value: '1',
          label: '一般类',
        },
      ],
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    handleOtherIs() {
      if (this.addFormData.pte_id != '-1') {
        this.addFormData.pte_else = ''
      }
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    // *审批
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/analysis_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    handleChange() {
      console.log(this.liRadioWithInputOptions)
    },
    async handleSubmit(val) {
      if (!this.addFormData.charge_opinions_time) {
        this.addFormData.charge_opinions_time = ''
      }
      if (!this.addFormData.approval_opinions_time) {
        this.addFormData.approval_opinions_time = ''
      }
      this.addFormData.analysis_1st = this.liRadioWithInputOptions[0].value
      this.addFormData.remark_of_analysis_1st =
        this.liRadioWithInputOptions[0].remark

      this.addFormData.analysis_2nd = this.liRadioWithInputOptions[1].value
      this.addFormData.remark_of_analysis_2nd =
        this.liRadioWithInputOptions[1].remark

      this.addFormData.analysis_3rd = this.liRadioWithInputOptions[2].value
      this.addFormData.remark_of_analysis_3rd =
        this.liRadioWithInputOptions[2].remark

      this.addFormData.analysis_4th = this.liRadioWithInputOptions[3].value
      this.addFormData.remark_of_analysis_4th =
        this.liRadioWithInputOptions[3].remark

      this.addFormData.analysis_5th = this.liRadioWithInputOptions[4].value
      this.addFormData.remark_of_analysis_5th =
        this.liRadioWithInputOptions[4].remark

      this.addFormData.analysis_6th = this.liRadioWithInputOptions[5].value
      this.addFormData.remark_of_analysis_6th =
        this.liRadioWithInputOptions[5].remark

      this.addFormData.analysis_7th = this.liRadioWithInputOptions[6].value
      this.addFormData.remark_of_analysis_7th =
        this.liRadioWithInputOptions[6].remark

      this.addFormData.analysis_8th = this.liRadioWithInputOptions[7].value
      this.addFormData.remark_of_analysis_8th =
        this.liRadioWithInputOptions[7].remark

      this.addFormData.analysis_9th = this.liRadioWithInputOptions[8].value
      this.addFormData.remark_of_analysis_9th =
        this.liRadioWithInputOptions[8].remark

      this.addFormData.analysis_10th = this.liRadioWithInputOptions[9].value
      this.addFormData.remark_of_analysis_10th =
        this.liRadioWithInputOptions[9].remark

      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)
        param.append('project_name', this.addFormData.project_name)
        param.append('annex', JSON.stringify(this.submitImgList))
        // param.append('pte_id', this.addFormData.pte_id)
        param.append('pte_id', this.cascaderArr[this.cascaderArr.length - 1])
        param.append('pte_else', this.addFormData.pte_else)
        param.append('analysts', this.addFormData.analysts)
        param.append('project_overview', this.addFormData.project_overview)
        param.append('analysis_1st', this.addFormData.analysis_1st)
        param.append('analysis_2nd', this.addFormData.analysis_2nd)
        param.append('analysis_3rd', this.addFormData.analysis_3rd)
        param.append('analysis_4th', this.addFormData.analysis_4th)
        param.append('analysis_5th', this.addFormData.analysis_5th)
        param.append('analysis_6th', this.addFormData.analysis_6th)
        param.append('analysis_7th', this.addFormData.analysis_7th)
        param.append('analysis_8th', this.addFormData.analysis_8th)
        param.append('analysis_9th', this.addFormData.analysis_9th)
        param.append('analysis_10th', this.addFormData.analysis_10th)
        param.append(
          'remark_of_analysis_1st',
          this.addFormData.remark_of_analysis_1st
        )
        param.append(
          'remark_of_analysis_2nd',
          this.addFormData.remark_of_analysis_2nd
        )
        param.append(
          'remark_of_analysis_3rd',
          this.addFormData.remark_of_analysis_3rd
        )
        param.append(
          'remark_of_analysis_4th',
          this.addFormData.remark_of_analysis_4th
        )
        param.append(
          'remark_of_analysis_5th',
          this.addFormData.remark_of_analysis_5th
        )
        param.append(
          'remark_of_analysis_6th',
          this.addFormData.remark_of_analysis_6th
        )
        param.append(
          'remark_of_analysis_7th',
          this.addFormData.remark_of_analysis_7th
        )
        param.append(
          'remark_of_analysis_8th',
          this.addFormData.remark_of_analysis_8th
        )
        param.append(
          'remark_of_analysis_9th',
          this.addFormData.remark_of_analysis_9th
        )
        param.append(
          'remark_of_analysis_10th',
          this.addFormData.remark_of_analysis_10th
        )
        param.append('charge_opinions', this.addFormData.charge_opinions)
        param.append(
          'charge_opinions_time',
          this.addFormData.charge_opinions_time
        )
        param.append('approval_opinions', this.addFormData.approval_opinions)
        param.append(
          'approval_opinions_time',
          this.addFormData.approval_opinions_time
        )
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/analysis',
          data: param,
        })
        console.log(this.addFormData)
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    handleDA() {
      console.log(this.addFormData.approval_opinions_time)
    },
    // *立项-项目分配-获取项目详情(当有projectid时)
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/analysis_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
        this.addFormData.project_type_name =
          res.datas.info.project_type_list[0].project_type_name
        // this.selectIds = this.addFormData.analysts.split(',')
        this.liRadioWithInputOptions[0].value = this.addFormData.analysis_1st
        this.liRadioWithInputOptions[0].remark =
          this.addFormData.remark_of_analysis_1st

        this.liRadioWithInputOptions[1].value = this.addFormData.analysis_2nd
        this.liRadioWithInputOptions[1].remark =
          this.addFormData.remark_of_analysis_2nd

        this.liRadioWithInputOptions[2].value = this.addFormData.analysis_3rd
        this.liRadioWithInputOptions[2].remark =
          this.addFormData.remark_of_analysis_3rd

        this.liRadioWithInputOptions[3].value = this.addFormData.analysis_4th
        this.liRadioWithInputOptions[3].remark =
          this.addFormData.remark_of_analysis_4th

        this.liRadioWithInputOptions[4].value = this.addFormData.analysis_5th
        this.liRadioWithInputOptions[4].remark =
          this.addFormData.remark_of_analysis_5th

        this.liRadioWithInputOptions[5].value = this.addFormData.analysis_6th
        this.liRadioWithInputOptions[5].remark =
          this.addFormData.remark_of_analysis_6th

        this.liRadioWithInputOptions[6].value = this.addFormData.analysis_7th
        this.liRadioWithInputOptions[6].remark =
          this.addFormData.remark_of_analysis_7th

        this.liRadioWithInputOptions[7].value = this.addFormData.analysis_8th
        this.liRadioWithInputOptions[7].remark =
          this.addFormData.remark_of_analysis_8th

        this.liRadioWithInputOptions[8].value = this.addFormData.analysis_9th
        this.liRadioWithInputOptions[8].remark =
          this.addFormData.remark_of_analysis_9th

        this.liRadioWithInputOptions[9].value = this.addFormData.analysis_10th
        this.liRadioWithInputOptions[9].remark =
          this.addFormData.remark_of_analysis_10th
        if (
          this.addFormData.is_draft != '1' &&
          this.addFormData.is_edit == '1'
        ) {
          this.isSubmit = false
        } else {
          this.isSubmit = true
        }
        if (this.addFormData.approval_opinions_time == '0') {
          this.addFormData.approval_opinions_time = ''
        }
        if (this.addFormData.charge_opinions_time == '0') {
          this.addFormData.charge_opinions_time = ''
        }
      } else {
        this.addFormData.is_edit = res.datas.info.is_edit
        this.addFormData.permit_type = res.datas.info.permit_type
        this.addFormData.project_type_name =
          res.datas.info.project_type_list[0].project_type_name
        if (
          this.addFormData.is_draft != '1' &&
          this.addFormData.is_edit == '1'
        ) {
          this.isSubmit = false
        } else {
          this.isSubmit = true
        }
      }
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      // 评价类型
      if (this.addFormData.pte_id) {
        this.cascaderArr = this.addFormData.pte_id
      }
      this.isComponentsShow = true
      console.log('项目评价风险分析表详情1', this.addFormData)
    },
    // 获取项目类型
    async getProjectTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.datas.listInfo
      console.log('项目类型列表', this.projectTypeList)
    },
    // 获取评价类型
    async getPjTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        // url: '/api/Project/evaluation_type',
        url: '/api/Management/pte_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectPjList = res.datas.listInfo
      console.log('评价类型列表', this.projectPjList)
    },
    transferChange(data) {
      this.addFormData.analysts = ''
      data.forEach((item) => {
        this.addFormData.analysts += item.id + ','
      })
      this.addFormData.analysts = this.addFormData.analysts.substring(
        0,
        this.addFormData.analysts.length - 1
      )
      console.log('自组建给父穿得选中的值--分析人员', data)
      console.log('asdasdasdasdas', this.addFormData.analysts)
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getProjectTypeList()
    this.getPjTypeList()
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  computed: {
    isTypeInputDis() {
      if (this.addFormData.pte_id == '-1') {
        return false
      } else {
        return true
      }
    },
  },
  components: {
    MyTransfer,
    ProjectFlow,
    UploadFile,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(./projectForm.less);
/deep/ .oneRow .el-radio-group .el-radio {
  width: auto !important;
  margin-right: 20px !important;
}
</style>